import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import prospectService from '../services/prospectService';
import partnerService from '../services/partnerService';
import './VaultSourceList.css';
import './ProspectsList.css';

const PartnerPickerModal = ({ prospect, onClose }) => {
  const navigate = useNavigate();
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    partnerService.getAllPartners()
      .then(res => setPartners(res.data?.partners || res.partners || res.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const filtered = partners.filter(p =>
    !search || (p.companyname || p.name || '').toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (partner) => {
    navigate(`/partners/${partner.partnerid}/account/new`, { state: { prospect } });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-dialog prospect-partner-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Select Partner</h2>
          <p className="modal-subtitle">
            Creating Hotel Chain for <strong>{prospect.company}</strong>
          </p>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <input
            className="modal-search"
            type="text"
            placeholder="Search partners..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoFocus
          />

          {loading ? (
            <div className="modal-loading">Loading partners...</div>
          ) : filtered.length === 0 ? (
            <div className="modal-empty">No partners found</div>
          ) : (
            <ul className="partner-pick-list">
              {filtered.map(p => (
                <li key={p.partnerid} className="partner-pick-item" onClick={() => handleSelect(p)}>
                  <span className="partner-pick-name">{p.companyname || p.name}</span>
                  {p.country && <span className="partner-pick-country">{p.country}</span>}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

const ProspectsList = () => {
  const [prospects, setProspects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [modalProspect, setModalProspect] = useState(null);

  useEffect(() => {
    loadProspects();
  }, []);

  const loadProspects = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await prospectService.getProspects();
      setProspects(response.prospects || []);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to load prospects');
    } finally {
      setLoading(false);
    }
  };

  const filteredProspects = prospects.filter((p) => {
    if (!searchTerm) return true;
    const q = searchTerm.toLowerCase();
    return (
      p.first_name?.toLowerCase().includes(q) ||
      p.last_name?.toLowerCase().includes(q) ||
      p.email?.toLowerCase().includes(q) ||
      p.company?.toLowerCase().includes(q)
    );
  });

  if (loading) {
    return <div className="loading">Loading prospects...</div>;
  }

  return (
    <div className="vaultsource-list-container">
      <div className="header">
        <h1>Prospects</h1>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by name, email or company..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button className="btn btn-secondary" onClick={() => setSearchTerm('')}>
          Clear
        </button>
      </div>

      <div className="table-container">
        <table className="vaultsource-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Company / Chain</th>
              <th>PMS</th>
              <th>Properties</th>
              <th>Submitted</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredProspects.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center', padding: '24px', color: '#6b7280' }}>
                  No prospects found
                </td>
              </tr>
            ) : (
              filteredProspects.map((p) => (
                <tr key={p.id}>
                  <td>{p.first_name} {p.last_name}</td>
                  <td>{p.email}</td>
                  <td>{p.company}</td>
                  <td>{p.pms || '—'}</td>
                  <td>{p.hotels || '—'}</td>
                  <td>{p.created_at ? new Date(p.created_at).toLocaleDateString() : '—'}</td>
                  <td className="actions-cell">
                    <button
                      className="btn-create-chain"
                      onClick={() => setModalProspect(p)}
                      title="Create Hotel Chain from this prospect"
                    >
                      + Create Hotel Chain
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {modalProspect && (
        <PartnerPickerModal
          prospect={modalProspect}
          onClose={() => setModalProspect(null)}
        />
      )}
    </div>
  );
};

export default ProspectsList;
